import "./style.scss";

import { Avatar } from "@mui/material";
import File from "assets/img/svg/file";
import { forwardRef, useCallback, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";

import StyledButton from "../StyledButton";

const buttonStyles = {
    "&.MuiButton-root": {
        borderRadius: "5px",
        padding: "8px 12px",
        backgroundColor: "#303030",
        border: "none",
        color: "white",
        "&:hover": {
            backgroundColor: "#464646",
        },
        "&.Mui-disabled": {
            backgroundColor: "#E9E9E9",
        },
    },
};

/**
 * @param portrait If the image uploaded is a 3:4 photo format, this props = true.
 */
const Upload = forwardRef((props: any, ref) => {
    const [t] = useTranslation();
    const { value, watchAvatar, onChange, portrait } = props;
    const inputRef = useRef<HTMLInputElement | null>(null);
    const firstRender = useRef(true);

    const avatarStyles = {
        square: { width: "150px", height: "150px" },
        portrait: { width: "150px", height: "auto" },
    };

    const imageSrc = useMemo(() => {
        if (typeof value === "object") {
            return URL.createObjectURL(value[0]);
        }
        return value;
    }, [value]);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        } else if (watchAvatar === "" && inputRef.current) {
            inputRef.current.value = "";
            // inputRef.current.click();
        }
    }, [watchAvatar]);

    const renderAvatar = useCallback(() => {
        if (imageSrc) {
            return (
                <Avatar
                    variant="rounded"
                    src={imageSrc}
                    alt="img"
                    imgProps={{ sx: { objectFit: "contain" } }}
                    sx={portrait ? avatarStyles.portrait : avatarStyles.square}
                />
            );
        }
        return (
            <>
                <label className="upload-box" htmlFor="raised-button-file">
                    <File />
                </label>
                <div className="input-control">
                    <StyledButton itemType="label" onClick={() => inputRef.current?.click()} sx={buttonStyles}>
                        {t("Upload.AddPicture")}
                    </StyledButton>
                    <label htmlFor="raised-button-file">
                        <span style={{ fontSize: "12px" }}>PNG or JPEG</span>
                    </label>
                </div>
            </>
        );
    }, [imageSrc, t]);

    return (
        <>
            <input
                ref={inputRef}
                onChange={(event) => onChange(event.target.files)}
                accept="image/*"
                style={{ display: "none" }}
                id="raised-button-file"
                type="file"
            />
            {renderAvatar()}
        </>
    );
});

Upload.displayName = "Upload";
export default Upload;
